import React, { memo } from "react"
import Link from "./link"
import copyWright from "../util/copyright"
import ReactMarkdown from "react-markdown"

const ProjectListing = ({ project, currentProject, onMouseEnter }) => {

  return (
    <Wrapper comingSoon={project.comingSoon} onMouseEnter={onMouseEnter} className={"link " + (project.comingSoon ? 'coming-soon' : '')} role='presentation' to={"/projects/" + project.slug}>
      <div className={"project--listed pt15 pb15 bt1 flex uppercase " + (project.name === currentProject ? 'active' : '')}>
        <div className='name text-light'>
          {project.name}
        </div>

        <ReactMarkdown className='scope text-light m0'>
          {project.scope}
        </ReactMarkdown>

        <div className='copyright m-text-right text-light'>
          {copyWright(project.year)}

        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = ({ comingSoon = false, children, ...props }) => {
  if (comingSoon) {
    return (
      <div {...props}>
        {children}
      </div>)
  } else {
    return (
      <Link  {...props}>
        {children}
      </Link>
    )
  }
}

export default memo(ProjectListing)
